import { useState } from "react"
import { ShowAnimeInfo } from "../components/ShowAnimeInfo.jsx"
import { getInfoFilms } from "../api.js";

export function FindfilmsPage() {


    const [animesInfo, setAnimesInfo] = useState({})
    const [input, setInput] = useState("")
    const [loading, setLoading] = useState(false)

    async function handleFind() {
        if(!input || input.length <= 0 || loading) return;
        setLoading(true)
        const data = await getInfoFilms(input)
        setLoading(false)
        console.log(data)
        return setAnimesInfo(data)
    }

    return (
        <div class="text-white">
            <h1 className="text-3xl text-center font-semibold mb-4 mt-10">Page de recherche d'un film</h1>
            {/* <hr className="mx-5" /> */}
            <h3 className="text-center my-2">Nous pouvons vous trouver des informations sur un film à partir de son nom</h3>

        
            <div className="mt-10 w-full justify-center items-center flex flex-wrap flex-row gap-4">
                <input onKeyDown={(e) => {
                    if(e.keyCode   === 13) handleFind()
                    else return;
                }} placeholder="Entrez le nom du film" className="container bg-gray-600 p-2 rounded-md text-white focus:outline-none" value={input} onChange={(e) => setInput(e.target.value)} />
            </div>
            <div className="mt-10 flex justify-center">
                <button onClick={() => handleFind()} className="py-2 px-10 bg-orange-500 rounded-lg">{loading ? "Chargement..." : "Rechercher"}</button>
            </div>

            <div className="mt-10 flex flex-wrap flex-row gap-8 justify-center">
                {animesInfo.length > 0 ?
                    animesInfo.map(animeInfo =>
                    ShowAnimeInfo(animeInfo)
                )
                    : <div>Aucun film trouvé</div>
                }
            </div>
        </div>
    )


}